import { useContext, useEffect, useRef } from "react"
import styles from "./styles.module.scss"
import { Wrapper, List, Page, Fade } from "components"
import cn from "clsx"
import { imageService } from "utils"
import type { FC, HTMLAttributes } from "react"
import type { Asset } from "storyblok/schema"
import type { Format } from "utils/imageService"

interface SectionProps
extends HTMLAttributes<HTMLDivElement> {}

export const AboutMe: FC<SectionProps> = ({ children, ...props }) => {
  const { content } = useContext(Page.Context)

  return (
    <Page.Section.Container {...props} id="about-me">
      <Fade>
        <Wrapper double>
          <Page.Section.Heading number={1}>
            About me
          </Page.Section.Heading>
          <Page.Section.Delimiter />
          <div className={styles.columns}>
            <Page.Section.Description content={content.summary}>
              <List.Container className={styles.list}
                id="skills" itemScope itemType="http://schema.org/ItemList">
                {content.skills.split('\n').map((skill, index) => (
                  <List.Item key={index}
                    itemProp="itemListElement">
                    {skill}
                  </List.Item>
                ))}
              </List.Container>
            </Page.Section.Description>
            <Picture {...content.photo} />
          </div>
        </Wrapper>
      </Fade>
    </Page.Section.Container>
  )
}

const sizes = [125, 250, 500]
const formats: Format[] = ['webp', 'jpeg']

const Picture: FC<Asset> = ({ filename, alt }) => {
  return (
    <picture className={styles.photo}>
      <div className={styles.corners}>
        <div className={cn(styles.topleft)} />
        <div className={cn(styles.topright)} />
        <div className={cn(styles.bottomleft)} />
        <div className={cn(styles.bottomright)} />
      </div>
      {formats.map((format, index) => (
        <source key={index} type={`image/${format}`}
          sizes="(min-width: 500px) 500px, 100vw" 
          srcSet={sizes.map(width => [
            imageService(filename, {
              resize: { width },
              filter: { format }
            }),
            `${width}w`,
          ].join(' ')).join(', ')} />
      ))}
      <img itemProp="image" decoding="async" alt={alt} src={filename} />
    </picture>
  )
}
